import { serviceRoutes, get } from "./index";

export const consultarSaldoEmisor = async ({ emisor }) =>
  get(serviceRoutes.consultarSaldoPosEmisor, `?id=${emisor}`);
